
  import { computed, defineComponent } from 'vue'
  import { Button } from '@up.law/uplaw-ui'
  import { useStore } from 'vuex'
  export default defineComponent({
    components: { Button },
    props: {
      errors: {
        type: Object as () => Record<string, string>,
        required: true
      },
      meta: {
        type: Object as () => any,
        required: true
      },
      isSubmitting: { type: Boolean, default: false },
      submittingText: { type: String, default: null }
    },
    emits: ['resetForm'],
    setup(props, { emit }) {
      const store = useStore()
      const errorsKeys = computed(() => Object.keys(props.errors).slice(0, 3))

      const initStockForm = () => {
        emit('resetForm')
        store.dispatch('organizations/INIT_MODAL_FORM', {
          ...store.getters['organizations/form'],
          modalInit: false,
          initCurrentForm: true
        })
      }
      return { initStockForm, errorsKeys }
    }
  })
